import img from "../../../assets/img/dashboard-img.png";

export default function DashboardImage() {
	return (
		<div className="w-full h-[271px]">
			<img
				className="w-full h-full"
				src={img}
				alt=""
				width={435}
				height={268}
			/>
		</div>
	);
}
